// Fallback / seed data for the blog. Used by BlogProvider when the Firestore
// `articles` collection is empty or unreachable, and uploaded by
// scripts/seedArticles.js. Shape mirrors the Firestore document model.

const sampleArticles = [
  {
    id: "school-year-closing-ceremony-2025-2026",
    status: "published",
    defaultLang: "ar",
    category: "events",
  
    tags: [
      "school-year-closing",
      "students",
      "education",
      "ceremony",
      "dar-mohammed-attaoui",
    ],
  
    author: "إدارة دار محمد عطاوي",
  
    coverImage: {
      path: "/Dar-Attaoui/Blog/1/cover.png",
      alt: "حفل اختتام الموسم الدراسي بدار محمد عطاوي",
    },
  
    createdAt: "2026-07-26T09:00:00.000Z",
    publishedAt: "2026-07-26T09:00:00.000Z",
    updatedAt: "2026-07-26T09:00:00.000Z",
  
    translations: {
      ar: {
        title: "حفل اختتام الموسم الدراسي 1447-1448هـ",
        slug: "حفل-اختتام-الموسم-الدراسي-1447-1448",
  
        excerpt:
          "حفل اختتام الموسم الدراسي 1447-1448هـ الموافق للموسم 2025-2026م، احتفاءً بجهود الطلبة والأطر التربوية والإدارية وأولياء الأمور.",
  
        readingTime: 1,
  
        seo: {
          title: "حفل اختتام الموسم الدراسي | دار محمد عطاوي",
          description:
            "تغطية حفل اختتام الموسم الدراسي 1447-1448هـ الموافق لـ2025-2026م، احتفاءً بجهود الطلبة والأطر التربوية والإدارية وأولياء الأمور.",
          keywords: [
            "حفل اختتام الموسم الدراسي",
            "دار محمد عطاوي",
            "الطلبة",
            "التعليم القرآني",
            "الطاقم التربوي",
          ],
        },
  
        content: [
          {
            type: "paragraph",
            text: "نظمت دار محمد عطاوي حفل اختتام الموسم الدراسي 1447-1448هـ، الموافق للموسم الدراسي 2025-2026م.",
          },
          {
            type: "paragraph",
            text: "كانت هذه المناسبة فرصة للاحتفاء بجهود الطلبة والأطر التربوية والإدارية وأولياء الأمور، وكل الفاعلين المساهمين في سير العمل وتنفيذ البرامج المسطرة خلال الموسم الدراسي.",
          },
          {
            type: "heading",
            level: 2,
            text: "فيديو الحفل",
          },
          {
            type: "video",
            url: "/Dar-Attaoui/Blog/1/main-video-1.mp4",
            mimeType: "video/mp4",
            title: "حفل اختتام الموسم الدراسي 1447-1448هـ",
            caption:
              "جانب من فعاليات حفل اختتام الموسم الدراسي بدار محمد عطاوي.",
            poster: "/Dar-Attaoui/Blog/1/cover.jpg",
            controls: true,
          },
        ],
      },
  
      fr: {
        title: "Cérémonie de clôture de l’année scolaire 2025-2026",
        slug: "ceremonie-cloture-annee-scolaire-2025-2026",
  
        excerpt:
          "Une cérémonie organisée pour célébrer les efforts des élèves, des équipes pédagogiques et administratives, des parents et de tous les acteurs de l’établissement.",
  
        readingTime: 1,
  
        seo: {
          title:
            "Cérémonie de clôture de l’année scolaire | Dar Mohammed Attaoui",
          description:
            "Retour en vidéo sur la cérémonie de clôture de l’année scolaire 2025-2026 organisée par Dar Mohammed Attaoui.",
          keywords: [
            "clôture de l’année scolaire",
            "Dar Mohammed Attaoui",
            "élèves",
            "équipe pédagogique",
            "enseignement coranique",
          ],
        },
  
        content: [
          {
            type: "paragraph",
            text: "Dar Mohammed Attaoui a organisé la cérémonie de clôture de l’année scolaire 1447-1448 de l’Hégire, correspondant à l’année scolaire 2025-2026.",
          },
          {
            type: "paragraph",
            text: "Cette occasion a permis de célébrer les efforts des élèves, des équipes pédagogiques et administratives, des parents ainsi que de tous les acteurs ayant contribué au bon déroulement des activités et des programmes prévus.",
          },
          {
            type: "heading",
            level: 2,
            text: "Vidéo de la cérémonie",
          },
          {
            type: "video",
            url: "/Dar-Attaoui/Blog/1/main-video-1.mp4",
            mimeType: "video/mp4",
            title: "Cérémonie de clôture de l’année scolaire 2025-2026",
            caption:
              "Quelques moments de la cérémonie de clôture organisée par Dar Mohammed Attaoui.",
            poster: "/Dar-Attaoui/Blog/1/cover.jpg",
            controls: true,
          },
        ],
      },
  
      en: {
        title: "2025-2026 School Year Closing Ceremony",
        slug: "school-year-closing-ceremony-2025-2026",
  
        excerpt:
          "A ceremony celebrating the efforts of students, educational and administrative teams, parents, and everyone who contributed throughout the school year.",
  
        readingTime: 1,
  
        seo: {
          title: "School Year Closing Ceremony | Dar Mohammed Attaoui",
          description:
            "Watch highlights from the 2025-2026 school year closing ceremony organized by Dar Mohammed Attaoui.",
          keywords: [
            "school year closing ceremony",
            "Dar Mohammed Attaoui",
            "students",
            "educational team",
            "Quranic education",
          ],
        },
  
        content: [
          {
            type: "paragraph",
            text: "Dar Mohammed Attaoui organized its closing ceremony for the 1447-1448 Hijri school year, corresponding to the 2025-2026 academic year.",
          },
          {
            type: "paragraph",
            text: "The event was an opportunity to celebrate the efforts of the students, educational and administrative teams, parents, and everyone who contributed to the successful implementation of the planned activities and programs.",
          },
          {
            type: "heading",
            level: 2,
            text: "Ceremony video",
          },
          {
            type: "video",
            url: "/Dar-Attaoui/Blog/1/main-video-1.mp4",
            mimeType: "video/mp4",
            title: "2025-2026 School Year Closing Ceremony",
            caption:
              "Highlights from the school year closing ceremony organized by Dar Mohammed Attaoui.",
            poster: "/Dar-Attaoui/Blog/1/cover.jpg",
            controls: true,
          },
        ],
      },
    },
  },
];

export default sampleArticles;
